import { type ContentRating, type Maybe } from '@tmdb-graphql-api/schema/types';
import { type BbfcCertification } from '../enums/certifications.ts';

export const getTvCertFromContentRatings = (contentRatings: Maybe<ContentRating>[] = [], country: string) =>
  contentRatings.reduce<BbfcCertification | undefined>((cert, contentRating) => {
    const isBbfcCertification = (_rating: string): _rating is BbfcCertification =>
      contentRating?.iso_3166_1 === country;

    if (contentRating && isBbfcCertification(contentRating.rating)) {
      return contentRating.rating;
    }

    return cert;
    // eslint-disable-next-line unicorn/no-useless-undefined
  }, undefined);
